module.exports = __webpack_public_path__ + "static/media/setup.d9f4e19d.webp";